import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";
import Modal, { Field, TextInput, Select, PrimaryButton, SecondaryButton } from "@/components/FormKit";
import { toast } from "sonner";

export default function Units() {
  const [items, setItems] = useState([]);
  const [towers, setTowers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ tower_id: "", unit_no: "", floor: 1, unit_type: "", size_sqft: "", status: "available" });

  const load = async () => {
    const [u, t] = await Promise.all([api.get("/company/units"), api.get("/company/towers")]);
    setItems(u.data);
    setTowers(t.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/company/units", {
        ...form,
        floor: form.floor ? Number(form.floor) : null,
        size_sqft: form.size_sqft ? Number(form.size_sqft) : null,
      });
      toast.success("Unit created");
      setOpen(false);
      setForm({ tower_id: "", unit_no: "", floor: 1, unit_type: "", size_sqft: "", status: "available" });
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="space-y-8" data-testid="company-units-page">
      <PageHeader
        eyebrow="Inventory"
        title="Units"
        description="Individual saleable units across your towers and projects."
        actions={<PrimaryButton onClick={() => setOpen(true)} testId="new-unit-button">+ New Unit</PrimaryButton>}
      />

      <DataTable
        testId="units-table"
        columns={[
          { key: "unit_no", label: "Unit #", render: (r) => <div className="font-bold font-mono">{r.unit_no}</div> },
          { key: "project", label: "Project", render: (r) => r.project?.name || "—" },
          { key: "tower", label: "Tower", render: (r) => r.tower?.name || "—" },
          { key: "unit_type", label: "Type" },
          { key: "floor", label: "Floor" },
          { key: "size_sqft", label: "Size (sqft)", render: (r) => r.size_sqft ?? "—" },
          { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
        ]}
        rows={items}
        empty="No units yet."
      />

      <Modal open={open} onClose={() => setOpen(false)} title="New unit">
        <form onSubmit={submit}>
          <Field label="Tower">
            <Select testId="form-unit-tower" required value={form.tower_id} onChange={(e) => setForm({ ...form, tower_id: e.target.value })}>
              <option value="">Select tower…</option>
              {towers.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </Select>
          </Field>
          <Field label="Unit number"><TextInput testId="form-unit-no" required value={form.unit_no} onChange={(e) => setForm({ ...form, unit_no: e.target.value })} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Floor"><TextInput testId="form-unit-floor" type="number" value={form.floor} onChange={(e) => setForm({ ...form, floor: e.target.value })} /></Field>
            <Field label="Type"><TextInput testId="form-unit-type" placeholder="e.g. 2BHK" value={form.unit_type} onChange={(e) => setForm({ ...form, unit_type: e.target.value })} /></Field>
            <Field label="Size (sqft)"><TextInput testId="form-unit-size" type="number" value={form.size_sqft} onChange={(e) => setForm({ ...form, size_sqft: e.target.value })} /></Field>
            <Field label="Status">
              <Select testId="form-unit-status" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                <option value="available">Available</option>
                <option value="booked">Booked</option>
                <option value="sold">Sold</option>
              </Select>
            </Field>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <SecondaryButton type="button" onClick={() => setOpen(false)}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" testId="submit-unit">Create</PrimaryButton>
          </div>
        </form>
      </Modal>
    </div>
  );
}
